import { createAction } from 'redux-act';
import axios from 'axios';

/**
 * Create the action
 */

const request = createAction('GET_ASSESSED_EVIDENCE_REQUEST');
const success = createAction('GET_ASSESSED_EVIDENCE_SUCCESS');
const error = createAction('GET_ASSESSED_EVIDENCE_ERROR');

function getAssessedEvidence() {
  return async function (dispatch, getState) {
    // Create default request
    const config = {
      headers: {
        Accept: 'application/json',
      },
      baseURL: '/api/',
    };

    // Retrieve token
    const { token } = getState().authentication;

    // Check if we need to do token stuff
    if (token) {
      // Add token to header
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token?.access_token}`,
      };
    }

    const fetch = axios.create(config);
    const response = await fetch.get('portfolio-assessed-evidence');
    return response.data;
  };
}

/**
 * Export the components
 */

export { getAssessedEvidence as default };
export { request, success, error };
